const envUtil = {
  STAGE: process.env.REACT_APP_STAGE || "",
  API_URL: process.env.REACT_APP_BASE_URL || "",
  NAVER: {
    CLIENT_ID: process.env.REACT_APP_NAVER_CLIENT_ID || "",
    CLIENT_SECRET: process.env.REACT_APP_NAVER_CLIENT_SECRET || "",
  },
  GOOGLE: {
    WEB_CLIENT_ID: process.env.REACT_APP_GOOGLE_WEB_CLIENT_ID || "",
    IOS_CLIENT_ID: process.env.REACT_APP_GOOGLE_IOS_CLIENT_ID || "",
  },
  KAKAO: {
    KEY: process.env.REACT_APP_KAKAO_KEY || "",
    JAVASCRIPT_KEY: process.env.REACT_APP_JAVASCRIPT_KAKAO_KEY || "",
  },
  CHANNELTALK: {
    KEY: process.env.REACT_APP_CHANNELTALK_PLUGIN_KEY || "",
  },
  APPLE: {
    KEY: process.env.REACT_APP_APPLE_KEY || "",
  },
};

export default envUtil;
